var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgent2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#214080;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.5,12.17V6.22h6.83l2.62-1.89-2.49-2.1h-6.96V.02h-1V7.2H2.54L.06,9.3l2.61,1.89h6.82v8.83h1v-3.86h6.83l2.62-1.89-2.49-2.1h-6.96Zm.14-8.94h6.46l1.23,1.04-1.32,.95h-6.37v-1.99Zm-1.27,6.96H3l-1.32-.95,1.23-1.04h6.45v1.99Zm7.64,4.97h-6.37v-1.99h6.46l1.23,1.04-1.32,.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgent2);
export default __webpack_public_path__ + "static/media/Agent-2.5f3475c631815157e2c35f811949727f.svg";
export { ForwardRef as ReactComponent };